module.exports = __webpack_public_path__ + "static/media/didemoon.6d2860fb.svg";